/**
 * auth.js — login, logout, guard, módulos habilitados.
 */
// Ver la nota de `utils.js`: `window.X`, no `const X`.
window.Auth = (() => {
  let _modules = [];
  let _permissions = {};   // {module: [acciones]} — ver Auth.can()

  function saveSession(data) {
    localStorage.setItem('token', data.access_token);
    localStorage.setItem('user', JSON.stringify({
      id: data.user_id, role: data.role,
      full_name: data.full_name,
      must_change_password: data.must_change_password,
      is_staff: data.is_staff || false,
      // "preregistro" => DatosIniciales.gate() le pide los datos que faltan
      status: data.status || 'activo',
    }));
  }

  function getUser() {
    try { return JSON.parse(localStorage.getItem('user')); } catch { return null; }
  }

  /** Actualiza el status de la sesión guardada sin reautenticar. Lo llama
   *  DatosIniciales tras completar el alta: si no, el gate se repetiría en
   *  cada navegación hasta el siguiente login. */
  function setUserStatus(status) {
    const u = getUser();
    if (!u) return;
    u.status = status;
    localStorage.setItem('user', JSON.stringify(u));
  }

  function isLoggedIn() { return !!localStorage.getItem('token'); }

  function logout() {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    _modules = [];
    // Detener el sondeo de notificaciones (evita 401 que reabra el login)
    if (window._notifPoll) { clearInterval(window._notifPoll); window._notifPoll = null; }
    // Al cerrar sesión vuelve al landing público (no directo al login)
    if (window.APP && window.APP.showLanding) window.APP.showLanding();
    else if (window.APP) window.APP.showLogin();
  }

  async function login(email, password) {
    const form = new URLSearchParams({ username: email, password });
    const res = await fetch('/api/auth/login', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: form.toString(),
    });
    if (!res.ok) {
      const e = await res.json().catch(() => ({}));
      throw new Error(e.detail || 'Credenciales incorrectas');
    }
    const data = await res.json();
    saveSession(data);
    return data;
  }

  async function loadModules() {
    try {
      const data = await API.get('/auth/my-modules');
      _modules = data?.modules || [];
      _permissions = data?.permissions || {};
    } catch {
      _modules = [];
      _permissions = {};
    }
    return _modules;
  }

  function hasModule(key) { return _modules.includes(key); }
  function getModules()   { return _modules; }

  /** ¿El usuario puede `action` sobre `module`? Mismo criterio que el backend.
   *  Reemplaza los chequeos por nombre de rol (`['coordinador','admin']`), que
   *  dejaban sin botones a los roles personalizados aunque estuvieran
   *  autorizados. Ante la duda responde false: es solo para mostrar u ocultar;
   *  quien de verdad autoriza es el servidor. */
  function can(module, action = 'view') {
    return (_permissions[module] || []).includes(action);
  }

  /** ¿Es un rol de GESTIÓN? Equivale a `require_role('coordinador','admin')`
   *  del servidor, que acepta cualquier rol marcado is_staff o is_admin.
   *
   *  Existe para no repetir `['coordinador','admin'].includes(role)` por las
   *  páginas: esa comparación por NOMBRE dejaba fuera a los roles creados a
   *  medida, aunque el servidor sí los autorizara. Se conserva la lista como
   *  respaldo para sesiones antiguas que no traigan is_staff. */
  function isStaff() {
    const u = getUser();
    return !!u && (u.is_staff === true || ['coordinador', 'admin'].includes(u.role));
  }

  return { login, logout, isLoggedIn, getUser, setUserStatus, loadModules, can, isStaff,
           hasModule, getModules };
})();
